import React, {ReactNode, useEffect, useState} from 'react';
import styled from 'styled-components';

const SCReciteQuran = styled.div`
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  margin: 1rem auto;
  width: fit-content;
  background-color: #f2f2f2;
  border-radius: 5px;
  .texts {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 1rem;
    .arabicText {
      text-align: right;
      /* white-space: nowrap;
      overflow: hidden; */
      p {
        font-family: 'Amiri Quran', serif;
        font-size: 1.3rem;
        text-align: right;
        display: inline-block;
        margin: 0;
      }
    }
    .portugueseText {
      line-height: 1.2rem;
    }
    .quranIndex {
      width: 100%;
      font-weight: bolder;
      text-align: end;
    }
  }
  @media screen and (min-width: 500px) {
    .texts {
      .arabicText {
        * {
          font-size: 2rem;
        }
      }
    }
  }
`;

interface ReciteProps {
  arabicText: ReactNode;
  portugueseText: ReactNode;
  quranIdex: string;
  surah?: number;
  ayat?: string;
}

interface QuranResults {
  arabic: {
    ayahNumber: string;
    ayahText: string;
  }[];
  translations: {
    translateAyahNumber: number;
    translateAyahText: string;
    translateLanguage: string;
  }[];
}

// TODO adicionar collapse tipo acordeon
export function ReciteQuran(props: ReciteProps) {
  const [teste, setTeste] = useState<QuranResults>();
  useEffect(() => {
    fetch(
      `http://localhost:3333/Quran/surah?number=${props.surah}&translations=br&verses=${props.ayat}`
    ).then(async (res) => setTeste(await res.json()));
  }, []);
  console.log(teste);
  return (
    <SCReciteQuran>
      <div className="texts">
        <div className="arabicText">{props.arabicText}</div>
        {/* <div className="arabicText arabicFont"> */}
        {/* {teste?.arabic.map((elem) => elem.ayahText)} */}
        {/* </div> */}
        <div className="portugueseText">
          <em>{props.portugueseText}</em>
          {/* <em> */}
          {/* {teste?.translations.map( */}
          {/* (translation) => translation.translateAyahText */}
          {/* )} */}
          {/* </em> */}
        </div>
        <div className="quranIndex">
          <span>
            <strong>Al-Qur'an {props.quranIdex}</strong>
            {/* <strong>Al-Qur'an {`${props.surah}:${props.ayat}`}</strong> */}
          </span>
        </div>
      </div>
    </SCReciteQuran>
  );
}
